<div class="modal-header impact-outcome-header">
    <div class="modal-title f-20">Bulk Update</div>
    <div class="modal-btn-right">
        <div class="btn-group mr-4">
            <button class="btn btn-blue text-white btn-sm mr-2" (click)="updateImpactAssessment()">Save</button>
        </div>
        <button class="fa fa-times" [mat-dialog-close]=""
            style="float: right;cursor: pointer;background: none;border:none" aria-hidden="true"></button>
    </div>
</div>
<div class="modal-body" style="height: 750px;overflow: auto;">
    <div class="pl-2 ia-details-div">
        <mat-accordion id="AssessmentDetails">
            <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
                <mat-expansion-panel-header class="ia-mat-panel">
                    <mat-panel-title>
                        <span class="text-header inc-f">
                            ASSESSMENT DETAILS
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row ml-2 my-4">
                    <div class="col-lg-6">
                        <label class="control-label fw">Response Lead</label>
                        <mat-chip-grid #responseLeadList>
                            <mat-chip-row *ngFor="let responseLead of responseLeadDD" [selectable]="selectable"
                                [removable]="removable" (removed)="removeResponseLead(responseLead)">
                                {{responseLead}}
                                <mat-icon matChipRemove *ngIf="removable" class="clear-icons">x</mat-icon>
                            </mat-chip-row>
                            <input class="form-control form-control-sm mat-autodd-input border-bottom"
                                #trigautoResponseLead="matAutocompleteTrigger"
                                (keydown)="getFilteredData('ResponseLead', $event)" #responseLeadInput
                                [formControl]="searchResponseLeadCntrl" [matAutocomplete]="responseLeadAutocomplete"
                                [matChipInputFor]="responseLeadList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                                autocomplete="off" (matChipInputTokenEnd)="addResponseLead($event)">
                        </mat-chip-grid>
                        <mat-autocomplete #responseLeadAutocomplete="matAutocomplete"
                            (optionSelected)="selectedResponseLeadEvent($event)">
                            <mat-option *ngFor="let responseLead of searchedResponseLead" [value]="responseLead.value">
                                {{responseLead.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div class="col-lg-6">
                        <label class="control-label fw">Accountable Executive</label>
                        <mat-chip-grid #accountableExecutiveList>
                            <mat-chip-row *ngFor="let accountableExecutive of accountableExecutiveDD"
                                [selectable]="selectable" [removable]="removable"
                                (removed)="removeAccountableExecutive(accountableExecutive)">
                                {{accountableExecutive}}
                                <mat-icon matChipRemove *ngIf="removable" class="clear-icons">x</mat-icon>
                            </mat-chip-row>
                            <input class="form-control form-control-sm mat-autodd-input border-bottom"
                                #trigautoAccountableExecutive="matAutocompleteTrigger"
                                (keydown)="getFilteredData('AccountableExecutive', $event)" #accountableExecutiveInput
                                [formControl]="searchAccountableExecutiveCntrl"
                                [matAutocomplete]="accountableExecutiveAutocomplete"
                                [matChipInputFor]="accountableExecutiveList"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                                autocomplete="off" (matChipInputTokenEnd)="addAccountableExecutive($event)">
                        </mat-chip-grid>
                        <mat-autocomplete #accountableExecutiveAutocomplete="matAutocomplete"
                            (optionSelected)="selectedAccountableExecutiveEvent($event)">
                            <mat-option *ngFor="let accountableExecutive of searchedAccountableExecutive"
                                [value]="accountableExecutive.value">
                                {{accountableExecutive.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                <div class="row ml-2">
                    <div class="col-lg-3">
                        <label class="control-label fw">Team</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.team">
                            <option *ngFor="let option of team" value="{{option}}">{{option}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Rule Type</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ruleType">
                            <option *ngFor="let option of ruleType" value="{{option}}">{{option}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Last Updated</label>
                        <div class="input-group input-group-sm">
                            <input matInput [matDatepicker]="lastUpdatedTime" disabled (click)="lastUpdatedTime.open()"
                                class="form-control form-control-sm border-bottom"
                                [(ngModel)]="impactAssessment.lastUpdatedTime" name="LastUpdatedTime" />
                            <div class="input-group-append">
                                <span class="input-group-text fa fa-calendar" disabled
                                    (click)="lastUpdatedTime.open()"></span>
                            </div>
                        </div>
                        <mat-datepicker #lastUpdatedTime></mat-datepicker>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label rag_ratingLabel fw">RAG Rating
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.ragRating">None</span>
                            <span class="label label-default p5-20" [style.background-color]="getBackgroundColor('Red')"
                                *ngIf="impactAssessment.ragRating === 'Red'">Red</span>
                            <span class="label ml-2 label-default p5-20"
                                [style.background-color]="getBackgroundColor('Amber')"
                                *ngIf="impactAssessment.ragRating === 'Amber'">Amber</span>
                            <span class="label ml-2 label-default p5-20"
                                [style.background-color]="getBackgroundColor('Green')"
                                *ngIf="impactAssessment.ragRating === 'Green'">Green</span>
                            <span class="label ml-2 label-default p5-20"
                                [style.background-color]="getBackgroundColor('No Impact')"
                                *ngIf="impactAssessment.ragRating === 'No Impact'">No Impact</span>
                        </label>
                        <div class="dropdown-color-selector">
                            <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.ragRating">
                                <option *ngFor="let option of ragRating" value="{{ option.itemTitle }}">
                                    {{ option.itemTitle }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-6">
                        <label class="control-label fw">Topic</label>
                        <mat-chip-grid #topicList>
                            <mat-chip-row *ngFor="let topic of ruleTopicDD" [selectable]="selectable"
                                [removable]="removable" (removed)="removeTopic(topic)">
                                {{topic}}
                                <mat-icon matChipRemove *ngIf="removable" class="clear-icons">x</mat-icon>
                            </mat-chip-row>
                            <input class="form-control form-control-sm mat-autodd-input border-bottom"
                                #trigautoTopicExecutive="matAutocompleteTrigger"
                                (keydown)="getFilteredData('RuleTopic', $event)" #topicInput
                                [formControl]="searchTopicCntrl" [matAutocomplete]="topicAutocomplete"
                                [matChipInputFor]="topicList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                                (matChipInputTokenEnd)="addTopic($event)">
                        </mat-chip-grid>
                        <mat-autocomplete #topicAutocomplete="matAutocomplete"
                            (optionSelected)="selectedTopicEvent($event)">
                            <mat-option *ngFor="let topic of searchedTopic" [value]="topic.value">
                                {{topic.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Effective Date</label>
                        <div class="input-group input-group-sm">
                            <input matInput [matDatepicker]="effectiveDate" (click)="effectiveDate.open()"
                                class="form-control form-control-sm border-bottom"
                                [(ngModel)]="impactAssessment.effectiveDate" name="EffectiveDate" />
                            <div class="input-group-append">
                                <span class="input-group-text fa fa-calendar" (click)="effectiveDate.open()"></span>
                            </div>
                        </div>
                        <mat-datepicker #effectiveDate></mat-datepicker>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Did We Respond?</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.didWeRespond">
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                        </select>
                    </div>

                    <!-- <div class="col-lg-3">
                            <label class="control-label fw">Response Deadline</label>
                            <div class="input-group input-group-sm">
                                <input matInput [matDatepicker]="resposeDeadline" (click)="resposeDeadline.open()"
                                    class="form-control form-control-sm border-bottom"
                                    (dateInput)="updateSectionLastEdited()"
                                    [(ngModel)]="impactAssessment.resposeDeadline" name="ResposeDeadline" />
                                <div class="input-group-append">
                                    <span class="input-group-text fa fa-calendar"
                                        (click)="resposeDeadline.open()"></span>
                                </div>
                            </div>
                            <mat-datepicker #resposeDeadline
                                (selectedChanged)="updateSectionLastEdited()"></mat-datepicker>
                        </div>
                        <div class="col-lg-3">
                            <label class="control-label fw">Consultation Period</label>
                            <input type="text" class="form-control form-control-sm"
                                [(ngModel)]="impactAssessment.consultationPeriod" disabled>
                        </div> -->
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-4">
                        <label class="control-label fw">Extension Requested?</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.extensionRequested">
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Response Approach</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.responseAppraoch">
                            <option *ngFor="let option of responseApproach" value="{{option}}">{{option}}</option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Response Submission Date</label>
                        <div class="input-group input-group-sm">
                            <input matInput [matDatepicker]="responseSubmissionDate"
                                (click)="responseSubmissionDate.open()"
                                class="form-control form-control-sm border-bottom"
                                [(ngModel)]="impactAssessment.responseSubmissionDate" name="ResponseSubmissionDate" />
                            <div class="input-group-append">
                                <span class="input-group-text fa fa-calendar"
                                    (click)="responseSubmissionDate.open()"></span>
                            </div>
                        </div>
                        <mat-datepicker #responseSubmissionDate></mat-datepicker>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-4">
                        <label class="control-label fw">Current Status</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.currentStatus">
                            <option *ngFor="let option of currentStatus" value="{{option}}">{{option}}</option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Next Action Date</label>
                        <div class="input-group input-group-sm">
                            <input matInput [matDatepicker]="nextActionDate" (click)="nextActionDate.open()"
                                class="form-control form-control-sm border-bottom"
                                [(ngModel)]="impactAssessment.nextActionDate" name="NextActionDate" />
                            <div class="input-group-append">
                                <span class="input-group-text fa fa-calendar" (click)="nextActionDate.open()"></span>
                            </div>
                        </div>
                        <mat-datepicker #nextActionDate></mat-datepicker>
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Next Action Step</label>
                        <input type="text" class="form-control form-control-sm"
                            [(ngModel)]="impactAssessment.nextActionStep">
                    </div>
                </div>
                <div class="row gap-2 ml-2 my-4">
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="control-label d-block fw mb-2">
                                    Policy Reform Summary
                                </span>
                            </div>

                            <app-ck-editor [(childVariable)]="impactAssessment.policyReformSummery"
                                id="policyReformSummery" class="f-16"
                                [data]="impactAssessment.policyReformSummery"></app-ck-editor>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="control-label d-block mb-2 fw">
                                    Response Key Messages
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.responseKeyMessages"
                                id="responseKeyMessages" class="f-16"
                                [data]="impactAssessment.responseKeyMessages"></app-ck-editor>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="control-label mb-2 d-block fw">
                                    External Stakeholder Positions
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.externalStakeHolderPositions"
                                id="externalStakeHolderPositions" class="f-16"
                                [data]="impactAssessment.externalStakeHolderPositions"></app-ck-editor>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="control-label mb-2 d-block fw">
                                    Internal Stakeholders and Packs
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.internalStakeholdersPacks"
                                id="internalStakeholdersPacks" class="f-16"
                                [data]="impactAssessment.internalStakeholdersPacks"></app-ck-editor>
                        </div>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-3 mb-3">
                        <label class="control-label fw">Engagement Plan</label>
                        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.engagementPlan">
                            <option *ngFor="let option of engagementPlan" value="{{option}}">{{option}}</option>
                        </select>
                    </div>
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="control-label d-block mb-2 fw">
                                    Engagement Plan Details
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.engagementPlanDetails"
                                id="engagementPlanDetails" class="f-16"
                                [data]="impactAssessment.engagementPlanDetails"></app-ck-editor>
                        </div>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-4">
                        <label class="control-label fw">Policy Response Achieved?</label>
                        <select class="form-control form-control-sm"
                            [(ngModel)]="impactAssessment.policyResponseAchieved">
                            <option *ngFor="let option of policyResponseAchieved" value="{{option}}">{{option}}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Number of Key Messages</label>
                        <input type="number" class="form-control form-control-sm"
                            [(ngModel)]="impactAssessment.numberofKeyMessages">
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Key Messages Acheived</label>
                        <input type="number" class="form-control form-control-sm"
                            [(ngModel)]="impactAssessment.keyMessagesAcheived">
                    </div>
                    <div class="col-lg-12 mt-3">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="control-label d-block mb-2 fw">
                                    Details
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.detail" id="detail" class="f-16"
                                [data]="impactAssessment.detail"></app-ck-editor>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>